import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #2299a5;
  background: #c6f6f5;
`

export const Description = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: ${theme.colors.secondary};
  `}
`

export const IconBox = styled(Box)`
  display: flex;
  align-items: center;
  color: #2299a5;
`

export const CountBadge = styled(Box)`
  ${({ theme }) => css`
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.lightest};
    background: ${theme.colors.teal.color};
    border-radius: 6px;
    padding: 4px 12px;
    white-space: nowrap;
  `}
`

export const ViewListButton = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #283897;
  background: #2299a540;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  white-space: nowrap;
`
